import { ROOT_MODULE_NAME } from '../constants/packagesConstants';

export const SET_SEARCH_SUBMITTING = `modules/${ROOT_MODULE_NAME}/SET_SEARCH_SUBMITTING`;

export const setIsSearchSubmitting = (isSubmitting = true) => ({
  type: SET_SEARCH_SUBMITTING,
  isSubmitting,
});
